import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { UserDataService } from '../features/user-data.service';



@Component({
  selector: 'app-master-data',
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.css']
})

export class MasterDataComponent implements OnInit {
  keyCode:any;
  portfolio:any;
  users:any;
  taslakBulusSay=0;
  kayitliBulusSay=0;
  kararVerilenBulusSay=0;
  toplamBulusSay=0;
  deletionRecords:any;
  deletionList:any;
  searchText:any;
  constructor(private route:Router, private auth:AuthService, private userData:UserDataService){}

  goInventorrecords() {
    this.route.navigate(['masterData/Inventors'])
  }

  goCompanyrecords() {

    this.route.navigate(['masterData/Companies'])
  }
  goAttorneyrecords() {
    this.route.navigate(['masterData/Attornies'])
  }
  goRDProjectrecords() {  this.route.navigate(['masterData/RDProjects'])}

  ngOnInit() {

    this.keyCode=this.auth.token;
    //console.log(this.keyCode)
    this.userData.fetchUsers(this.keyCode).
    subscribe(res=>
      {//console.log(res);
        this.portfolio=res;
        this.toplamBulusSay=(Object.keys(this.portfolio).length);
      this.users=(Object.keys(this.portfolio).map((key)=>{return this.portfolio[key]}));
      //console.log(this.users);
      for (let value of this.users) {
        if(value[0].status.slice(-1)[0].status == "taslak buluş") {this.taslakBulusSay++;
        console.log(this.taslakBulusSay)}
        else if(value[0].status.slice(-1)[0].status == "kabul edilmiş buluş") {this.kayitliBulusSay++;
          console.log(this.kayitliBulusSay)}

        else if(value[0].status.slice(-1)[0].status.includes("karar")) {this.kararVerilenBulusSay++;
            console.log(this.kararVerilenBulusSay)}

         }


       });

 //  fetchdeletionRecords
        this.userData.fetchdeletionRecords(this.keyCode).subscribe(res=>{this.deletionList=res;
          this.deletionRecords=(Object.keys(this.deletionList).map((key)=>{return this.deletionList[key]}));
         // console.log(this.deletionRecords);
        })

      }
      dataDeletionRecords() {

      }

}


